import { NgModule } from '@angular/core';

import { TimeManagementSharedModule } from './timemanagement-shared.module';
import { TimeManagementRoutesModule } from './timemanagement.routes';
import { TimeManagementService } from './service/timemanagement.service';

/**
 * CoreModule for TimeManagement.
 */
@NgModule( {
    imports: [
        TimeManagementSharedModule,
        TimeManagementRoutesModule
    ],
    declarations: [
    ],
    exports: [
        TimeManagementSharedModule
    ],
    providers: [
        TimeManagementService
    ],
} )

export class TimeManagementCoreModule {
}
